var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 42,
    height: 42,
    transform: "translate(440 489)",
    fill: "#ebc5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05235d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305eba"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-440 -489)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fit",
    transform: "translate(438.6 487.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M37.815,31.462a8.338,8.338,0,0,0-1.333-6.418,6.334,6.334,0,0,0-.365-5.051,7.328,7.328,0,0,0-4.364-3.152l-5.707-3.073A4.88,4.88,0,0,0,27.3,10.5V4.9a3.5,3.5,0,0,0-3.5-3.5H21a3.5,3.5,0,0,0-3.5,3.5v5.6a4.88,4.88,0,0,0,1.253,3.269l-5.707,3.073a7.328,7.328,0,0,0-4.364,3.152,6.334,6.334,0,0,0-.365,5.051,8.338,8.338,0,0,0-1.333,6.418A32.928,32.928,0,0,0,6.3,42.777.7.7,0,0,0,7,43.4h3.5a.7.7,0,0,0,.686-.563A38.934,38.934,0,0,0,11.9,36.4c0-1.518.959-3.6,1.887-5.622.219-.475.433-.942.633-1.4l.98,6.372V42.7a.7.7,0,0,0,.7.7H28.7a.7.7,0,0,0,.7-.7V35.754l.98-6.372c.2.454.415.921.633,1.4.928,2.018,1.887,4.1,1.887,5.622a38.933,38.933,0,0,0,.714,6.437.7.7,0,0,0,.686.563h3.5a.7.7,0,0,0,.7-.623A32.916,32.916,0,0,0,37.815,31.462ZM18.9,10.5V9.08a6.089,6.089,0,0,0,4.237-1.613A5.257,5.257,0,0,0,25.9,9.015V10.5a3.5,3.5,0,1,1-7,0Zm0-5.6A2.1,2.1,0,0,1,21,2.8h2.8a2.1,2.1,0,0,1,2.1,2.1V7.577a3.974,3.974,0,0,1-2.218-1.666A.7.7,0,0,0,23,5.592a.676.676,0,0,0-.557.479c-.055.13-.671,1.423-3.538,1.607Zm9.108,30.694A.7.7,0,0,0,28,35.7V42H16.8V35.7a.7.7,0,0,0-.008-.106l-1.062-6.9a4.872,4.872,0,0,0,5.236.234l1.405-.8.975.65a4.911,4.911,0,0,0,5.745-.226ZM37.167,42H34.882a35.974,35.974,0,0,1-.582-5.6c0-1.824-1.024-4.052-2.015-6.207a24.212,24.212,0,0,1-1.506-3.763.7.7,0,0,0-1.174-.325h0L28.54,27.171a3.509,3.509,0,0,1-4.416.438l-1.335-.89a.7.7,0,0,0-.736-.025l-1.781,1.018a3.483,3.483,0,0,1-4.47-.852l-.553-.691v0h0a.7.7,0,0,0-1.226.267,24.2,24.2,0,0,1-1.506,3.762C11.524,32.348,10.5,34.576,10.5,36.4A35.974,35.974,0,0,1,9.918,42H7.633a31.551,31.551,0,0,1,.74-10.307.7.7,0,0,0,.017-.307c-.626-3.756,1.133-5.616,1.2-5.69a.7.7,0,0,0,.169-.716A5.184,5.184,0,0,1,9.9,20.692a6.048,6.048,0,0,1,3.556-2.509.7.7,0,0,0,.18-.067l6.294-3.389a4.884,4.884,0,0,0,4.947,0l6.294,3.389a.715.715,0,0,0,.178.067A6.049,6.049,0,0,1,34.9,20.692a5.183,5.183,0,0,1,.132,4.287.7.7,0,0,0,.169.716c.018.018,1.838,1.889,1.2,5.69a.7.7,0,0,0,.017.307A31.413,31.413,0,0,1,37.167,42Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M25.9,17.5H24.5a.7.7,0,0,0-.388.118L22.4,18.759l-1.712-1.141A.7.7,0,0,0,20.3,17.5H18.9a.7.7,0,1,0,0,1.4h1.188l1.924,1.282a.7.7,0,0,0,.777,0L24.712,18.9H25.9a.7.7,0,1,0,0-1.4Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M25.2,33.6a.7.7,0,1,0,0-1.4H23.1V30.8a.7.7,0,0,0-1.4,0v1.4H19.6a.7.7,0,1,0,0,1.4h2.1V35H19.6a.7.7,0,1,0,0,1.4h2.1v2.1a.7.7,0,1,0,1.4,0V36.4h2.1a.7.7,0,1,0,0-1.4H23.1V33.6Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitActive);
export default __webpack_public_path__ + "static/media/fit-active.9897b434ad382e9a674d17210462f493.svg";
export { ForwardRef as ReactComponent };